import $ from 'jquery';
import DDTemplates from 'dd-templates';

import Hero from './Hero';
import Menu from './Menu';
import Split from './Split';
import Drupal from './Drupal';
import Header from './Header';
import Sticky from './Sticky';
import Gallery from './Gallery';
import Toolbar from './Toolbar';
import Parallax from './Parallax';
import Stripper from './Stripper';
import MobileMenu from './MobileMenu';
import SmartFooter from './SmartFooter';
import CalendarFeed from './CalendarFeed';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';

// Add the theme behaviors
Drupal.behavior((context) => {
  // Helpers
  const $body = $(document.body, context);

  // DD Template Behaviors
  // eslint-disable-next-line no-new
  new DDTemplates(context);

  // Hero w/Quicklinks block
  $('.hero.block', context).each((i, element) => {
    const $quicklinks = $('.home-quicklinks.block', context);
    if (!element.Hero && $quicklinks.length) {
      element.Hero = new Hero(element, $quicklinks);
    }
  });

  // Term Banner
  $('.banner.block .field-image a', context).each((i, element) => {
    if (!element.Parallax) {
      element.Parallax = new Parallax(element);
    }
  });

  // Life Events
  $('.life-events.block .node-header .title', context).each((i, element) => {
    if (!element.Split) {
      element.Split = new Split(element);
    }
  });

  // Sticky sidebars
  $('.page-sidebar', context).each((i, element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // SEEK AND DESTROY ... unwanted hyperlinks
  $('.footer-links .node-header a, .overview .node-header a', context).each((i, element) => {
    if (!element.Stripper) {
      element.Stripper = new Stripper(element);
    }
  });

  // Fix our damn menus from displaying orphaned children
  $('.primary-navigation, .term-nav', context).each((i, element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Main/Primary Site Navigation
  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.Menu && !element.MobileMenu) {
      element.Menu = new Menu(element);
      element.MobileMenu = new MobileMenu(element);
    }
  });

  // Controls the states of the menu and search states
  $('.toolbar', context).each((i, element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // Controls the page overlay display
  $('.overlay', context).bind('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Fixed Header using Headroom.js
  $('.headroom', context).each((i, element) => {
    if (!element.Header) {
      element.Header = new Header(element);
    }
  });

  // Smart Footer
  $('.page-footer', context).each((i, element) => {
    const $footprint = $('.footprint', context);
    if (!element.SmartFooter && $footprint.length) {
      element.SmartFooter = new SmartFooter(element, $footprint);
    }
  });

  // Term Navigation
  $('.term-nav', context).each((i, element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Photo Galleries
  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.Gallery) {
      element.Gallery = new Gallery(element);
    }
  });

  // Calendar of Events View
  $('.calendar-feed', context).each((i, element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element);
    }
  });

  // Open Pod PDF links in new window/tab
  $('.pods .node-item a[href$=".pdf"]', context).each((i, element) => {
    $(element).attr('target', '_blank');
  });

  // Add Sitemap output using the digitaldcore.js function
  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }

  const searchInput = document.querySelector('#edit-keywords');
  if (searchInput) {
    searchInput.setAttribute('aria-label', 'Search Keywords');
  }

  const searchForm = document.querySelector('form');
  if (searchForm) {
    searchForm.setAttribute('role', 'Search Form');
  }
});



// WEBPACK FOOTER //
// ./theme.js